const ShipsyAdapter = require('./data-access/adapter')
const createBatchHelpers = require('./batches')
const createReturnToSupplier = require('./handlers/return-to-supplier')
const createInventoryAdjustment = require('./handlers/inventory-adjustment')
const createGrnCreation = require('./handlers/grn-creation')
const createInvoiceCallback = require('./handlers/invoice-callback')
const createSalesReturn = require('./handlers/sales-return')

class ShipsyApi {
  constructor (shipsyApiConfigs = {}, isomorphicFetch, agaveAdapter, logger, user, pgConnection, mainApi) {
    this.fetch = isomorphicFetch
    this.agaveAdapter = agaveAdapter
    this.pgConnection = pgConnection
    this.logger = logger
    this.user = user
    this.mainApi = mainApi
    this.shipsyAdapter = new ShipsyAdapter(shipsyApiConfigs, this.fetch, logger, mainApi)
    const batchHelpers = createBatchHelpers({ mainApi, logger })
    this.batchHelpers = batchHelpers
    this.handlers = {
      returnToSupplier: createReturnToSupplier({ mainApi, batches: batchHelpers }),
      inventoryAdjustment: createInventoryAdjustment({ mainApi, logger, batches: batchHelpers }),
      grnCreation: createGrnCreation({ mainApi, logger, batches: batchHelpers }),
      invoiceCallback: createInvoiceCallback({ mainApi, logger, batches: batchHelpers }),
      salesReturn: createSalesReturn({ mainApi, logger, batches: batchHelpers })
    }
  }

  returnToSupplier (params = {}) {
    return this.handlers.returnToSupplier(params)
  }

  inventoryAdjustment (params) {
    return this.handlers.inventoryAdjustment(params)
  }

  grnCreation (params) {
    return this.handlers.grnCreation(params)
  }

  invoiceCallback (params) {
    return this.handlers.invoiceCallback(params)
  }

  salesReturn (params) {
    return this.handlers.salesReturn(params)
  }
}

module.exports = ShipsyApi
